import { render, staticRenderFns } from "./InviteCashbackPanel.vue?vue&type=template&id=1f064a88&scoped=true"
import script from "./InviteCashbackPanel.vue?vue&type=script&lang=js"
export * from "./InviteCashbackPanel.vue?vue&type=script&lang=js"
import style0 from "./InviteCashbackPanel.vue?vue&type=style&index=0&id=1f064a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f064a88",
  null
  
)

export default component.exports